"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAsyncStateInfo = void 0;
var useAsyncStateInfo_1 = require("./useAsyncStateInfo");
Object.defineProperty(exports, "useAsyncStateInfo", { enumerable: true, get: function () { return useAsyncStateInfo_1.useAsyncStateInfo; } });
//# sourceMappingURL=index.js.map